"use client";

import React, { useMemo } from "react";
import { Pagination, PaginationItem } from "@nextui-org/pagination";
import { useRouter } from "next/navigation";
import { Stuff } from "@prisma/client";
import { PRE_PAGE_SIZE } from "@repo/web/lib/utils/consts";
import { Link } from "@nextui-org/link";
import { Card, CardBody, CardHeader } from "@nextui-org/card";
import { Image } from "@nextui-org/image";
import AudioPlayer from "react-h5-audio-player";
import { Button } from "@nextui-org/button";
type StuffListProps = {
  data: Stuff[]
  page: number
  total: number
}

export function StuffList({ total, data, page }: StuffListProps) {
  const totalPages = useMemo(() => Math.ceil(total / PRE_PAGE_SIZE), [total]);


  return <section
    className="w-full   overflow-hidden flex flex-col justify-center">
    <div className="grid grid-cols-1 md:grid-cols-5 mt-3 md:mt-12 j  gap-y-8">
      {
        data.map((it, index) => (
          <StuffCard key={`stuff_${index}`} {...it} />
        ))
      }
    </div>
    <div className="flex items-center justify-center md:justify-end mt-5 mx-5">
      <Pagination loop  total={totalPages}
        boundaries={5}
        initialPage={1}
        page={page}
        size="lg"
        renderItem={(item) => (
          <PaginationItem
            {...item}
            as={Link}
            key={item.value}
            href={`/explore/index/${item.value}`}
          />
        )}
      />
    </div>
  </section>;
}

type StuffCardProps = {} & Stuff

export function StuffCard({ id, name, cover, business }: StuffCardProps) {
  let type = business==='vocals'?'纯人声':'伴奏'
  return <div className="w-full flex justify-center">
    <Link
      className="hover:scale-105"
      href={`/explore/${business}/${id}/${name}`}>
      <Card className="py-4 w-[280px] text-center">
        <CardHeader className="pb-0 pt-2 px-4 flex-col items-start">
          <p className="text-tiny uppercase font-bold">{type}</p>
          <h4 className="font-bold text-large truncate">{name}</h4>
        </CardHeader>
        <CardBody className="overflow-visible flex justify-center py-2 text-center">
          <img
            alt="Card background"
            className="object-cover rounded-xl"
            src={cover ?? "/explore/images/image-holder.jpeg"}
            width={280}
          />
        </CardBody>
      </Card>
    </Link>
  </div>;
}


type StuffPlayerCardProps = { subtitle: string } & Stuff

export function StuffPlayerCard({ name, business, subtitle, path, wordMarkdown }: StuffPlayerCardProps) {
  return <section className="bg-banner mt-4 p-4 md:p-10 rounded-lg text-center relative">
    <h1 className="pt-4 md:pt-8 font-bold text-2xl md:text-4xl text-gray-700">{name}{subtitle}</h1>
    <h2 className="py-2 md:py-4 text-sm md:text-base text-gray-500">在线试听和下载《{name}{subtitle}》</h2>
    <div className="pb-4 md:pb-8 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 items-center justify-center">
      <div className="relative col-span-1 md:col-span-2 md:col-start-2 mb-4 md:mb-0">
        <Image
          alt="Album cover"
          className="object-cover mx-auto"
          height={200}
          src="/explore/images/image-holder.jpeg"
          width="100%"
        />
      </div>

      <div className="flex flex-col col-span-1 md:col-span-8 bg-gray-100 rounded p-3 md:p-5 h-auto md:h-[200px]">
        <div className="flex justify-between items-start mb-2 md:mb-0">
          <div className="flex flex-col gap-0 items-start px-2 md:px-4">
            <h1 className="text-base md:text-large font-medium mt-1 md:mt-2">{name}</h1>
            <p className="text-xs md:text-small text-foreground/80">Audio MP3</p>
            <h3 className="text-sm md:text-base font-semibold text-foreground/90">类型：{business==='vocals'?'纯人声':'伴奏'}</h3>
          </div>
        </div>

        <div className="mt-2 md:mt-4">
          <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
            <AudioPlayer
              autoPlay={false}
              layout="horizontal-reverse"
              className="rounded-lg w-full md:w-auto"
              style={{ boxShadow: "0 0 0" }}
              preload={"metadata"}
              customAdditionalControls={[]}
              src={path}
            />
            <Button
              as={Link}
              size="sm"
              color="primary"
              variant="flat"
              href={path}
              download={name}
              target="_blank"
              className="w-full md:w-auto mt-2 md:mt-0"
            >
              下载文件
            </Button>
          </div>
        </div>
        
      </div>
    </div>
  </section>;
}